// app/javascript/modules/admissoes/bulk_approval.js

export function initAdmissoesBulkApproval(rootEl, service) {
  const btn = rootEl.querySelector("[data-admissoes-bulk-approve]");
  if (!btn) return { destroy() { } };

  const selectAll = rootEl.querySelector("[data-admissoes-bulk-select-all]");
  const rowCheckboxes = () => Array.from(rootEl.querySelectorAll("[data-admissoes-bulk-checkbox]"));
  const enabledRowCheckboxes = () => rowCheckboxes().filter(c => !c.disabled);

  const getIds = () =>
    enabledRowCheckboxes()
      .filter(el => el.checked)
      .map(el => el.value)
      .filter(Boolean);

  const aceiteEl = () => rootEl.querySelector("[data-admissoes-aceite-aprovacao]");
  const aceiteContainer = rootEl.querySelector("[data-admissoes-aceite-container]");

  const refresh = () => {
    const ids = getIds();
    const aceite = aceiteEl();

    if (aceiteContainer) {
      if (ids.length > 0) {
        aceiteContainer.classList.remove("hidden");
      } else {
        aceiteContainer.classList.add("hidden");
        if (aceite) aceite.checked = false;
      }
    }

    btn.disabled = ids.length === 0 || (aceite !== null && !aceite.checked);

    if (selectAll) {
      const enabled = enabledRowCheckboxes();
      selectAll.checked = enabled.length > 0 && enabled.every(c => c.checked);
    }
  };

  const onToggleAll = () => {
    const checked = !!selectAll?.checked;
    enabledRowCheckboxes().forEach(c => (c.checked = checked));
    refresh();
  };

  const onRowChange = () => refresh();

  const clickBulkApprove = async (e) => {
    e.preventDefault();
    const ids = getIds();
    if (ids.length === 0) return;

    const ok = await service.confirmBulkApprove(ids.length);
    if (!ok) return;

    btn.disabled = true;

    try {
      await service.bulkApprove(ids);
      window.location.reload();
    } catch (err) {
      btn.disabled = false;
      await service.showError("Erro ao aprovar em lote", err?.message || "Falha ao aprovar.");
      refresh();
    }
  };

  const onClickCancelApproval = async (e) => {
    const el = e.target.closest(".js-cancelar-aprovacao-admissao-item");
    if (!el) return;

    if (el.getAttribute("aria-disabled") === "true" || el.classList.contains("pointer-events-none")) return;

    e.preventDefault();

    const url = el.dataset.url;
    if (!url) return;

    const ok = await service.confirmCancel();
    if (!ok) return;

    el.classList.add("opacity-50", "pointer-events-none");

    try {
      await service.cancelApproval(url);
      window.location.reload();
    } catch (err) {
      el.classList.remove("opacity-50", "pointer-events-none");
      await service.showError("Erro ao cancelar", err?.message || "Falha ao cancelar.");
    }
  };

  const onAceiteChange = () => refresh();

  btn.addEventListener("click", clickBulkApprove);
  if (selectAll) selectAll.addEventListener("change", onToggleAll);
  rowCheckboxes().forEach(c => c.addEventListener("change", onRowChange));
  rootEl.addEventListener("click", onClickCancelApproval);
  rootEl.addEventListener("change", (e) => {
    if (e.target.hasAttribute("data-admissoes-aceite-aprovacao")) refresh();
  });

  refresh();

  return {
    destroy() {
      btn.removeEventListener("click", clickBulkApprove);
      if (selectAll) selectAll.removeEventListener("change", onToggleAll);
      rowCheckboxes().forEach(c => c.removeEventListener("change", onRowChange));
      rootEl.removeEventListener("click", onClickCancelApproval);
    },
  };
}
